type RuntimeVariant = 'production' | 'demo';

type FirebaseWebConfig = {
  apiKey: string;
  authDomain: string;
  projectId: string;
  appId: string;
  messagingSenderId?: string;
  storageBucket?: string;
  measurementId?: string;
};

const FIREBASE_CONFIG_BY_VARIANT: Record<RuntimeVariant, FirebaseWebConfig> = {
  production: {
    apiKey: 'AIzaSyCN8002NnoOrx95gZznIZ4J0NC97VkkSgs',
    authDomain: 'xavvi-app.firebaseapp.com',
    projectId: 'xavvi-app',
    storageBucket: 'xavvi-app.firebasestorage.app',
    messagingSenderId: '1061939565945',
    appId: '1:1061939565945:web:6ca2ecedbe97e18634cba8',
    measurementId: 'G-PW6LFWNZ16',
  },
  demo: {
    apiKey: 'AIzaSyDaH6hZ4z5I2kLRnBIoWezPTD2hVXIZxUM',
    authDomain: 'bfcapp-bbe36.firebaseapp.com',
    projectId: 'bfcapp-bbe36',
    storageBucket: 'bfcapp-bbe36.firebasestorage.app',
    messagingSenderId: '741488773920',
    appId: '1:741488773920:web:10541bc685b5b6075ea545',
    measurementId: 'G-1GSKPT0YN2',
  },
};

function getHostname(): string {
  if (typeof window === 'undefined') {
    return 'onboarding.xavvi.com';
  }

  return window.location.hostname.toLowerCase();
}

export function getRuntimeVariant(): RuntimeVariant {
  const host = getHostname();
  const explicitVariant = import.meta.env.VITE_APP_VARIANT?.toLowerCase();

  if (explicitVariant === 'demo') {
    return 'demo';
  }

  if (
    host === 'onboarding-demo.xavvi.com' ||
    host === 'demo-onboarding.xavvi.com' ||
    host === 'xavvi-onboarding-demo.pages.dev' ||
    host.endsWith('.xavvi-onboarding-demo.pages.dev')
  ) {
    return 'demo';
  }

  return 'production';
}

function applyFirebaseEnvOverrides(baseConfig: FirebaseWebConfig): FirebaseWebConfig {
  return {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || baseConfig.apiKey,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || baseConfig.authDomain,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || baseConfig.projectId,
    appId: import.meta.env.VITE_FIREBASE_APP_ID || baseConfig.appId,
    messagingSenderId:
      import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || baseConfig.messagingSenderId,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || baseConfig.storageBucket,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || baseConfig.measurementId,
  };
}

export function getFirebaseWebConfig(): FirebaseWebConfig {
  return applyFirebaseEnvOverrides(FIREBASE_CONFIG_BY_VARIANT[getRuntimeVariant()]);
}

export function getOnboardingOrigin(): string {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }

  return getRuntimeVariant() === 'demo'
    ? 'https://onboarding-demo.xavvi.com'
    : 'https://onboarding.xavvi.com';
}

export function getAppOrigin(): string {
  return getRuntimeVariant() === 'demo' ? 'https://demo.xavvi.com' : 'https://app.xavvi.com';
}

export function getTermsUrl(): string {
  return `${getAppOrigin()}/terms`;
}

export function getPrivacyUrl(): string {
  return `${getAppOrigin()}/privacy`;
}

export function getAppLaunchUrl(): string {
  return getAppOrigin();
}

export function normalizeReferralUrl(input: string | null): string | null {
  if (!input) {
    return null;
  }

  try {
    const url = new URL(input);
    if (url.pathname.startsWith('/onboarding')) {
      return `${getOnboardingOrigin()}${url.pathname}${url.search}${url.hash}`;
    }
    return url.toString();
  } catch {
    return input;
  }
}
